import { useState } from "react";
import "./InnerHam.scss";

const InnerHam = () => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* Toggle Container */}
      <div className="innerHam-container">
        <div
          className={`astro-toggle ${open ? "open" : ""}`}
          onClick={() => setOpen(!open)}
          title="Explore Astrology Services"
        >
          <div className="toggle-content">
            <span className="icon">{open ? "☽" : "☀"}</span>
            <span className="label">Explore</span>
          </div>
        </div>
      </div>

      {/* Side Menu */}
      <aside className={`side-menu ${open ? "open" : ""}`}>
        <ul>
          <li><a href="/Love-Horoscope">❤️ Love Horoscope</a></li>
          <li><a href="/career-counselling">🎓 Career Counselling</a></li>
          <li><a href="/Gemstone">💎 Gemstone Suggestions</a></li>
          <li><a href="/Learn-astrology">📘 Learn Astrology</a></li>
          <li><a href="/ephemeris">🪐 Ephemeris</a></li>
          <li><a href="/ephemeris/extended">🌌 Extended Ephemeris</a></li>
        </ul>
      </aside>

      {/* Overlay */}
      {open && <div className="overlay" onClick={() => setOpen(false)} />}
    </>
  );
};

export default InnerHam;
